export default {
  EUR: 'i.iii,dd €',
  USD: '$i,iii.dd'
} as Record<string, string>;
